import React from 'react';

import { classes } from './DockPoint.classes';
import { DockPointProps } from './DockPoint.types';
import { DATA_HOOKS } from '../../Dock.constants';

const toLabel = (position: string) => {
  const spaced = position.replace('-', ' ');

  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

const DockPoint = (props: DockPointProps) => {
  const { position, selected, disabled, offsetIcon, icon, onClick } = props;

  return (
    <button
      type="button"
      data-hook={DATA_HOOKS.point(position)}
      className={classes.root({ position, selected, disabled, offsetIcon })}
      aria-label={toLabel(position)}
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
    >
      <span className={classes.background()}>
        {selected && icon ? (
          <span className={classes.icon()}>{icon}</span>
        ) : (
          <span className={classes.indicator()} />
        )}
      </span>
    </button>
  );
};

DockPoint.displayName = 'DockPoint';

export { DockPoint };
